<template>
  <div>
    <v-content class="pt-0">
      <div class="table__overflow">
        <table class="datatable table">
          <thead>
            <tr>
              <th role="columnheader" scope="col" class="column text-xs-left">Email</th>
              <th role="columnheader" scope="col" class="column text-xs-left">Type</th>
              <th role="columnheader" scope="col" class="column text-xs-left">Name</th>
              <th role="columnheader" scope="col" class="column text-xs-center padding-off">Subscription</th>
              <th role="columnheader" scope="col" class="column text-xs-left"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user, index) in users" :key="index">
              <td class="text-xs-left">{{user.email}}</td>
              <td class="text-xs-left">{{getType(user.role)}}</td>
              <td class="text-xs-left">{{user.name}}</td>
              <td class="text-xs-right padding-off">
                <v-checkbox :value="1" @change="subscribe(user, index)" v-model="user.isSubscribed"></v-checkbox>
              </td>
              <td class="text-xs-right padding-off td-flex">
                <v-btn fab dark small color="primary" @click.stop="editUserTrigger(user, index)">
                  <v-icon dark>edit</v-icon>
                </v-btn>
                <v-btn fab dark small color="accent" @click.stop="deleteUser(user, index)">
                  <v-icon dark>close</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-content>
    <v-alert color="error" icon="warning" v-if="err" :value="err !== ''">
      {{err}}
    </v-alert>
    <v-dialog v-model="dialogEdit" max-width="500px">
      <edit-modal modalType="User" v-if="dialogEdit" :user="editUser" :index="editIndex" @close="closeEdit" @submit="submitEdit"></edit-modal>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <delete-modal modalType="User" path="user" :id="deleteId" v-if="dialogDelete" @close="dialogDelete = false" @submit="submitDelete"></delete-modal>
    </v-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import webHelper from '../../helpers/web';
  import EditUser from '../modals/User';
  import Delete from '../modals/Delete';

  export default {
    data: () => ({
      headers: [
        {
          text: 'Email',
          sortable: false,
          value: 'email',
        },
        {
          text: 'Password',
          sortable: false,
          value: 'password',
        },
        {
          text: 'Role',
          sortable: false,
          value: 'role',
        },
        {
          text: 'Name',
          sortable: false,
          value: 'name',
        },
        {
          text: 'Subscription',
          sortable: false,
          value: 'subscription',
        },
      ],
      editUser: null,
      editIndex: null,
      deleteId: null,
      dialogEdit: false,
      deleteIndex: null,
      dialogDelete: false,
      err: '',
    }),
    computed: mapGetters({
      users: 'users',
    }),
    methods: {
      editUserTrigger(user, index) {
        this.editUser = user;
        this.editIndex = index;
        this.dialogEdit = true;
      },
      closeEdit() {
        this.editUser = null;
        this.editIndex = null;
        this.dialogEdit = false;
      },
      submitEdit(event) {
        this.$store.dispatch('user_editUser', { index: this.editIndex, user: event });
        this.closeEdit();
      },
      deleteUser(user, index) {
        this.deleteId = user._id;
        this.deleteIndex = index;
        this.dialogDelete = true;
      },
      async submitDelete() {
        this.$store.dispatch('removeUser', this.deleteIndex);
        this.deleteId = null;
        this.deleteIndex = null;
        this.dialogDelete = false;
      },
      getType(type) {
        switch (parseInt(type, 10)) {
          case 1:
            return 'OPs';
          case 2:
            return 'Admin';
          case 3:
            return 'Suites';
          case 0:
          default:
            return 'Sales';
        }
      },
      async subscribe(user, index) {
        const data = user;
        const value = user.isSubscribed ? 1 : 0;
        const res = await webHelper.put(this, 'user', { id: user._id, isSubscribed: value });
        if (res.failed) {
          this.err = 'Failed to edit user subscription.';
          data.isSubscribed = !data.isSubscribed;
        }
        this.$store.dispatch('editUser', { index, user: data });
      },
    },
    components: {
      deleteModal: Delete,
      editModal: EditUser,
    },
    async created() {
      const res = await webHelper.get(this, 'user');
      if (res === null) {
        this.err = 'Failed to get the Users.';
        return;
      }
      this.$store.dispatch('setUsers', res.users);
    },
  };
</script>

<style scoped lang="scss">
  .padding-off {
    padding: 0 !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/eventManager/Users.vue